<template lang="html">
  <div class="main" v-loading="loading" element-loading-background="rgba(255, 255, 255, 0)">
    <div class="main-cell">
      <h3> {{message.Sl233}} </h3>
        <el-button
          type="primary"
          @click.native="searchRequest"
          class="search"
          :disabled="desktop"
        >
          {{ message.Fl118 }}
        </el-button>
        <el-input
          :placeholder="message.SRl107"
          prefix-icon="el-icon-search"
          v-model="searchText">
        </el-input>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          @click.native="breadClick(-1)"
        >
          {{ message.SRl105 }}
        </el-breadcrumb-item>
        <el-breadcrumb-item
          v-for="(item, index) in breadList"
          :key="index"
          @click.native="breadClick(index)"
        >
          {{item}}
        </el-breadcrumb-item>
      </el-breadcrumb>

      <el-button
        type="primary"
        class="retrieve"
        plain
        :disabled="desktop"
        :style="{visibility: showBotton ? 'visible' : 'hidden'}"
        :loading="loadingBtn"
        @click.native="retrieveRequest"
      >
      {{ message.SRl104 }}
      </el-button>
      <div class="wl-main-list">
        <el-table
          v-loading="boxLoading"
          highlight-current-row
          class="wl-table"
          ref="checkTable"
          :data="tableData"
          :row-key="getRowKey"
          @sort-change="changeSort"
          @selection-change="selectionChange"
          @cell-click="handleCellClick"
        >
          <el-table-column
            align="center"
            type="selection"
            width="80"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column
            v-for="i of selfColumns"
            show-overflow-tooltip
            :key="i._id"
            :prop="i.prop"
            :width="i.width"
            :label="i.label"
            :align="i.align"
            :sort-by="i.sortBy"
            :sortable="i.sortable"
            :min-width="i.minWidth"
            :formatter="i.formatter"
            :sort-method="i.sortMethod"
          >
            <template slot-scope="scope">
              <template v-if="i.prop !== 'name'">
                {{
                  i.formatter
                    ? i.formatter(scope.row)
                    : scope.row[i.prop]
                }}
              </template>
              <div v-else
                class="wl-name-col wl-is-folder"
              >
              <el-popover
                placement="bottom-start"
                trigger="hover"
                >
                 {{ scope.row.path }}
                <div slot="reference" class="name-wrapper">
                  <div class="namecol-iconbox">
                    <img
                      :src="fileTypeIcon(scope.row)"
                      class="name-col-icon"
                      alt="File Icon"
                    />
                  </div>
                  <div class="namecol-textbox">
                    {{
                      i.formatter
                        ? i.formatter(scope.row)
                        : scope.row[i.prop]
                    }}
                  </div>
                </div>
              </el-popover>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Store from '@/store'
import _this from '@/main'

export default {
  beforeRouteEnter (to, from, next) {
    if (!Store.state.app.login && Store.state.app.login !== null) {
      _this.$app.login(0, response => {
        if (response === 2) {
          _this.$app.start()
        }
      })
    } else {
      next()
    }
  },
  data () {
    return {
      boxLoading: false,
      showBotton: false,
      loadingBtn: false,
      isSearch: false,
      desktop: false,
      totalNum: 0,
      currentPage: 1,
      currentPath: '',
      searchText: '',
      pageSize: 30,
      sort: '',
      order: '',
      offset: 0,
      breadList: [],
      message: {
        SRl100: this.$lang.ui.system.retrieve.l00,
        SRl101: this.$lang.ui.system.retrieve.l01,
        SRl102: this.$lang.ui.system.retrieve.l02,
        SRl103: this.$lang.ui.system.retrieve.l03,
        SRl104: this.$lang.ui.system.retrieve.l04,
        SRl105: this.$lang.ui.system.retrieve.l05,
        SRl106: this.$lang.ui.system.retrieve.l06,
        SRl107: this.$lang.ui.system.retrieve.l07,
        Sl233: this.$lang.ui.system.l233,
        Fl118: this.$lang.ui.form.l118,
      },
      loading: false,
      tableData: [],
      selectedData: [],
      columns: []
    }
  },
  created () {
    this.retrieveList()
    const _KB = 1024
    const _MB = _KB * _KB
    const _GB = _MB * _KB
    this.columns = [
      {
        label: this.message.SRl100,
        prop: 'name',
        minWidth: 100,
        sortable: 'custom'
      },
      {
        label: this.message.SRl101,
        minWidth: 70,
        align: 'right',
        formatter (row) {
          if (row.size === null) return '-'
          if (row.size < _KB) {
            return row.size + ' B'
          }
          if (row.size < _MB) {
            let _kb = (row.size / _KB).toFixed(0)
            return parseFloat(_kb) + ' KB'
          }
          if (row.size < _GB) {
            let _mb = (row.size / _MB).toFixed(0)
            return parseFloat(_mb) + ' MB'
          }
          let _gb = (row.size / _GB).toFixed(2)
          return parseFloat(_gb) + ' GB'
        },
      },
      {
        label: this.message.SRl102,
        align: 'center',
        minWidth: 85,
        formatter (row) {
          return row.date.match(/(.+)T/)[1] +
                 ' ' +
                 row.date.match(/(\d+):(\d+)/)[0] || '-'
        },
        sortable: 'custom',
        prop: 'date',
      },
    ]
    let state = {
      params: {
        path: ''
      }
    }
    window.history.replaceState(state, 'title', '')
    window.addEventListener('popstate', this.popstate)
  },
  destroyed () {
    window.removeEventListener('popstate', this.popstate)
  },
  computed: {
    selfColumns () {
      let _data = this.columns || []
      _data.forEach((i, idx) => {
        i._id = `_col_${idx}`
      })
      return _data
    },
  },
  watch: {
    selectedData (val) {
      this.showBotton = val.length !== 0
    },
    currentPath (val) {
      if (history.state.params.path !== val) {
        let state = {
          params: {
            path: val,
          }
        }
        window.history.pushState(state, 'title', '')
      }
      this.breadList = val.split('/')
      if (this.breadList[0] === '') {
        this.breadList.splice(0, 1)
      }
      if (this.breadList[this.breadList.length - 1] === '') {
        this.breadList.pop()
      }
    },
    '$store.state.app.login': function (newVal) {
      this.desktop = !newVal
    },
  },
  methods: {
    searchRequest () {
      this.isSearch = true
      this.currentPage = 1
      this.currentPath = ''
      this.retrieveList({
        filename: this.searchText
      })
    },
    popstate () {
      this.isSearch = false
      this.$refs.checkTable.clearSelection()
      this.searchText = ''
      this.currentPath = history.state.params.path
      this.retrieveList()
    },
    retrieveRequest () {
      this.loadingBtn = true
      this.boxLoading = true

      let encryption
      this.$app.getSettings(response => {
        if (response.encryptionType === 0) {
          encryption = false
        } else if (response.encryptionType === 5) {
          encryption = true
        }
        var e = {
          project_id: localStorage.getItem('projectId'),
          file_paths: this.selectedData,
          encryption: encryption
        }
        this.$api.retrieveFile(e, response => {
          if (response !== 1) {
            this.$message({
              message: this.message.SRl106,
              type: 'success',
              duration: 1200
            })
          } else {
            this.$message({
              message: this.$lang.systemError.l182,
              type: 'error',
              duration: 1200
            })
          }
          setTimeout(() => {
            if (response !== 1) {
              this.selectedData = []
              this.$refs.checkTable.clearSelection()
            }
            this.loadingBtn = false
          }, 3000)
        })
        this.boxLoading = false
      })
    },
    getRowKey (row) {
      return row.path
    },
    breadClick (num) {
      if (num === -1) {
        this.isSearch = false
        this.searchText = ''
      }
      this.breadList.splice(num + 1)
      this.currentPath = this.breadList.join('/')
      this.$refs.checkTable.clearSelection()
      this.retrieveList()
    },
    changeSort (val) {
      this.currentPage = 1
      let params = {
        sort: val.prop,
        order: val.order === 'descending' ? 'desc' : '',
      }
      if (this.isSearch) {
        params.filename = this.searchText
      }
      this.retrieveList(params)
      this.sort = val.prop
      this.order = val.order
    },
    handleCellClick (row, column) {
      if (column.className === 'el-table-column--selection') {
        this.$refs.checkTable.toggleRowSelection(row)
      } else if (row.is_folder) {
        this.isSearch = false
        this.$refs.checkTable.clearSelection()
        this.searchText = ''
        this.currentPath = row.path
        this.retrieveList()
      }
    },
    handleCurrentChange (val) {
      this.offset = (val - 1) * this.pageSize
      let params = {
        offset: this.offset,
        sort: this.sort,
        order: this.order,
      }
      if (this.isSearch) {
        params.filename = this.searchText
      }
      this.retrieveList(params)
    },
    selectionChange (val) {
      this.selectedData = val.map(v => v.path)
    },
    retrieveList (params = {}) {
      this.boxLoading = true
      params.project_id = localStorage.getItem('projectId')
      params.path = this.currentPath
      this.$api.getRetrieveList(params, response => {
        if (response !== 1) {
          this.tableData = response.files
          this.totalNum = response.total_num
        } else {
          this.$message({
            message: this.$lang.systemError.l182,
            type: 'error',
            duration: 1200
          })
        }
        this.boxLoading = false
        if (!this.isSearch && params.path === '') {
          let list = Array.from(document.getElementsByClassName('el-breadcrumb__inner'))
          let innerLast = list.slice(-1)[0]
          innerLast.style.color = '#606266'
          innerLast.style.cursor = 'text'
          innerLast.onmouseover = function () {
            this.style.textDecoration = 'none'
          }
        } else {
          let list = document.getElementsByClassName('el-breadcrumb__inner')
          list[0].style.color = '#327bbf'
          list[0].style.cursor = 'pointer'
          list[0].onmouseover = function () {
            this.style.textDecoration = 'underline'
          }
          list[0].onmouseout = function () {
            this.style.textDecoration = 'none'
          }
        }
      })
      return 0
    },
    fileTypeIcon (row) {
      let _path = ''
      if (row.is_folder) {
        _path = require('../../../assets/icons/folder.png')
        return _path
      }
      let _suffix = row.name.split('.').slice(-1)[0]
      if (!_suffix) {
        _path = require('../../../assets/icons/file_none.png')
        return _path
      }
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(_suffix)) {
        _path = require('../../../assets/icons/file_img.png')
      } else if (['zip', 'rar', '7z'].includes(_suffix)) {
        _path = require('../../../assets/icons/file_zip.png')
      } else if (
        ['avi', 'mp4', 'rmvb', 'flv', 'mov', 'm2v', 'mkv'].includes(_suffix)
      ) {
        _path = require('../../../assets/icons/file_video.png')
      } else if (['mp3', 'wav', 'wmv', 'wma'].includes(_suffix)) {
        _path = require('../../../assets/icons/file_mp3.png')
      } else if (['xls', 'xlsx'].includes(_suffix)) {
        _path = require('../../../assets/icons/file_excel.png')
      } else if (['doc', 'docx'].includes(_suffix)) {
        _path = require('../../../assets/icons/file_docx.png')
      } else if (_suffix === 'pdf') {
        _path = require('../../../assets/icons/file_pdf.png')
      } else if (_suffix === 'ppt') {
        _path = require('../../../assets/icons/file_ppt.png')
      } else if (_suffix === 'txt') {
        _path = require('../../../assets/icons/file_txt.png')
      } else {
        _path = require('../../../assets/icons/file_none.png')
      }
      return _path
    },
  }
}
</script>

<style scoped lang="css">
.main {
  position: relative;
  padding: 5px;
  min-height: calc(100% - 45px);
}
.main-cell {
  min-width: 570px;
}
.wl-table >>> th {
  background-color: #f9f9f9;
  text-align: center;
  color: #666;
  font-weight: 600;
  padding: 12px 0px;
}
.wl-table >>> thead .cell {
  height: 24px;
}
.wl-table >>> .ascending {
  border-top-width: 0px;
}
.wl-table >>> .descending {
  border-bottom-width: 0px;
}
.wl-table >>> .caret-wrapper {
  height: 24px;
}
.wl-table >>> .el-table__row {
  cursor: pointer;
}
.wl-table >>> .namecol-textbox {
  position: relative;
  text-overflow: ellipsis;
  top: -5px;
}
.wl-table >>> .name-wrapper {
  height: 22px;
}
.el-breadcrumb >>> .el-breadcrumb__inner {
  cursor: pointer;
  padding: 0px 1px;
  color: #327bbf;
}
.el-breadcrumb >>> .el-breadcrumb__item:not(:last-child) .el-breadcrumb__inner:after {
  position: absolute;
  width: 4.5px;
  height: 200%;
  background-color: #FFF;
  content: ".";
  text-indent: -9999em;
  margin-left: -4px;
}
.el-breadcrumb >>> .el-breadcrumb__item:not(:last-child) .el-breadcrumb__inner:hover {
  text-decoration:underline;
}
.el-breadcrumb >>> .el-breadcrumb__separator {
  margin-right: 3px;
  margin-left: 0px;
}
.el-breadcrumb >>> .el-breadcrumb__item {
  position: relative;
  top: 100%;
  transform: translateY(-180%);
  margin-top: 20px;
  height: 15px;
}
.el-breadcrumb {
  column-width: calc(100% - 200px);
  display: table;
  height: 40px;
}
h3 {
  margin: 18px 0px 25px;
}
.retrieve {
  float: right;
  margin: 20px 0px 30px;
}
.namecol-iconbox, .namecol-textbox {
  display: inline;
}
.wl-name-col {
  display: flex;
  height: 20px;
}
.namecol-iconbox {
  padding-right: 10px;
}
.el-pagination {
  margin: 25px 30px 100px;
}
.el-input {
  float: right;
  width: 40%
}
.search {
  float: right;
  margin-left: 5px;
}

</style>
